<template>
  <div v-if="currentEntretienIndividuel">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Date et heure de l'entretien
                    </span>
                  </td>
                  <td>
                    {{ currentEntretienIndividuel.date_entretien }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Responsable </span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentEntretienIndividuel.responsable.prenom
                        ? currentEntretienIndividuel.responsable.prenom +
                          ' ' +
                          currentEntretienIndividuel.responsable.nom
                        : currentEntretienIndividuel.responsable.nom
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentEntretienIndividuel.document.created_by.prenom
                        ? currentEntretienIndividuel.document.created_by
                            .prenom +
                          ' ' +
                          currentEntretienIndividuel.document.created_by.nom
                        : currentEntretienIndividuel.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Type d'entretien</span>
                  </td>
                  <td>
                    {{ currentEntretienIndividuel.header.entretien_type.nom }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Employé </span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentEntretienIndividuel.header.employe.prenom
                        ? currentEntretienIndividuel.header.employe.prenom +
                          ' ' +
                          currentEntretienIndividuel.header.employe.nom
                        : currentEntretienIndividuel.header.employe.nom
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="
                        getClassOfEntretien(currentEntretienIndividuel.statut)
                      "
                    ></i>
                    {{ getStatutEntretien(currentEntretienIndividuel.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('entretien', ['currentEntretienIndividuel']),
  },
};
</script>

<style scoped></style>
